export enum LegalDocumentType {
  HTML = 'html',
  PDF = 'pdf',
  LINK = 'link',
}
